import { createFileRoute } from "@tanstack/react-router";
import AbrirTiendaEnEspana from "@/pages/AbrirTiendaEnEspana";

// Nota SEO: title/description/og:*/twitter:*/canonical los emite <SEO />
// (Helmet, también en SSR) dentro de SolutionProgramPage.
export const Route = createFileRoute("/en/open-a-store-in-spain")({
  component: AbrirTiendaEnEspana,
});
